import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "max-w-[1084px] px-3 xl:px-[50px] mx-auto h-full" }
const _hoisted_2 = { class: "flex flex-col items-start sm:flex-row sm:items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-2 pb-[9px]" }
const _hoisted_4 = { class: "text-xl leading-[26px] font-medium text-primary-text-color tracking-[0.01rem]" }
const _hoisted_5 = {
  key: 1,
  class: "text-xl leading-[26px] font-medium text-primary-text-color tracking-[0.01rem]"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "h-[calc(100vh-120px)] overflow-y-scroll" }
const _hoisted_9 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-3 mb-5" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

import { Project } from "@/types";
import BasicDetails from "./BasicDetails.vue";
import ProjectDocuments from "./ProjectDocuments.vue";
import TerminTimeline from "./TerminTimeline.vue";
import ProjectAppointments from "./ProjectAppointments.vue";
import ThreeBlockRow from "./ThreeBlockRow.vue";

import { ref } from "vue";
import InlineLoader from "@/components/Loaders/InlineLoader.vue";
import { getProjectStatusColor } from "@/utils/status-color";

type Props = {
  projectDetails: Project | null;
  isLoading: boolean;
};

type Emits = {
  (event: "refresh"): void;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectOverview',
  props: {
    projectDetails: {},
    isLoading: { type: Boolean }
  },
  emits: ["refresh"],
  setup(__props: any) {

const isTimeline = ref(true);
const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          (__props.isLoading)
            ? (_openBlock(), _createBlock(InlineLoader, { key: 0 }))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.projectDetails?.name ? __props.projectDetails?.name : ""), 1))
        ]),
        (__props.isLoading)
          ? (_openBlock(), _createBlock(InlineLoader, { key: 0 }))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "text-sm tracking-[0.01rem] text-primary-text-color px-[6px] py-[2px] rounded-primary-radius",
              style: _normalizeStyle({
            backgroundColor: `${_unref(getProjectStatusColor)(
              __props.projectDetails?.status?.id
            )}`,
          })
            }, _toDisplayString(__props.projectDetails ? __props.projectDetails?.status?.name : ""), 5))
      ]),
      (__props.projectDetails?.customerLogo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("img", {
              src: __props.projectDetails?.customerLogo,
              alt: "Customer logo",
              width: "84"
            }, null, 8, _hoisted_7)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, [
        _createVNode(ThreeBlockRow, {
          "is-loading": __props.isLoading,
          "customer-name": __props.projectDetails ? __props.projectDetails?.name : '',
          "cost-carrier-code": 
            __props.projectDetails ? __props.projectDetails?.costCarrierCode + '' : ''
          ,
          meister: __props.projectDetails ? __props.projectDetails?.meister : '',
          "next-termin": __props.projectDetails ? __props.projectDetails.nextTermin : '',
          "last-termin": __props.projectDetails ? __props.projectDetails.lastTermin : ''
        }, null, 8, ["is-loading", "customer-name", "cost-carrier-code", "meister", "next-termin", "last-termin"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(BasicDetails, {
          "is-loading": __props.isLoading,
          "project-id": String(__props.projectDetails?.id),
          vnb: __props.projectDetails?.vnb,
          wechselrichter: __props.projectDetails?.wechselrichter,
          speicher: __props.projectDetails?.speicher,
          masskonzept: __props.projectDetails?.masskonzept,
          wb: __props.projectDetails?.wb,
          "number-of-modules": __props.projectDetails?.numberOfModules,
          "modul-type": __props.projectDetails?.modulType,
          "ibn-date": __props.projectDetails?.ibnDate,
          "home-owner-name": __props.projectDetails?.homeownerName,
          "home-owner-address": __props.projectDetails?.homeownerAddress,
          "home-owner-phone": __props.projectDetails?.homeownerPhone,
          "email-address": __props.projectDetails?.ownerEmail,
          strings: __props.projectDetails?.strings,
          "module-fields": __props.projectDetails?.moduleFields,
          bauabschnitt: __props.projectDetails?.bauabschnitt,
          bauabschnittDetails: __props.projectDetails?.bauabschnittDetails,
          onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('refresh')))
        }, null, 8, ["is-loading", "project-id", "vnb", "wechselrichter", "speicher", "masskonzept", "wb", "number-of-modules", "modul-type", "ibn-date", "home-owner-name", "home-owner-address", "home-owner-phone", "email-address", "strings", "module-fields", "bauabschnitt", "bauabschnittDetails"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          (isTimeline.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(TerminTimeline, {
                  "is-loading": __props.isLoading,
                  projectDetails: __props.projectDetails,
                  onShowAppointments: _cache[1] || (_cache[1] = ($event: any) => (isTimeline.value = false))
                }, null, 8, ["is-loading", "projectDetails"])
              ]))
            : _createCommentVNode("", true),
          (!isTimeline.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(ProjectAppointments, {
                  projectDetails: __props.projectDetails,
                  onShowTimeline: _cache[2] || (_cache[2] = ($event: any) => (isTimeline.value = true))
                }, null, 8, ["projectDetails"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createVNode(ProjectDocuments, {
            "is-loading": __props.isLoading,
            projectDetails: __props.projectDetails,
            onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('refresh')))
          }, null, 8, ["is-loading", "projectDetails"])
        ])
      ])
    ])
  ]))
}
}

})